import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[nrcModalContainer]',
  standalone: true
})
export class ModalContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
